module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-556248de!./packages/dof-swiper/colmo.css
// module id = 481
// module chunks = 0 1